import * as t from "io-ts";
import { Document } from "./Document";

export const CompanyReport = t.type({
  status: t.string,
  incorporation_date: t.string,
  number_of_writs: t.number,
  active_ccj_exact: t.number,
  active_ccj_possible: t.number,
  satisfied_ccj: t.number,
  risk_score: t.string,
  credit_limit: t.string,
  report_pdf: Document,
  people_ids: t.array(t.string),
});

export interface CompanyReport {
  status: string;
  incorporation_date: string;
  number_of_writs: number;
  active_ccj_exact: number;
  active_ccj_possible: number;
  satisfied_ccj: number;
  risk_score: string;
  credit_limit: string;
  report_pdf: Document;
  people_ids: Array<string>;
}
